import { projektGajaChapters } from './content';
export const projektGajaCommonMistakes = projektGajaChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('NAJCZĘSTSZE BŁĘDY'));
